angular.module("ainapp")
    .controller("EarningDeductionController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Earnings & Deductions";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.Components = [];
            MainService.PayrollComponentsForED().then(function (response) {
                $scope.Components = response.data;
            })

            $scope.Years = [2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030];
            $scope.Months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

            $scope.loadVoucher = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.EarningDeductionsById(data).then(function (response) {
                    if (response.data != null) {
                        $scope.addData = response.data;
                        $scope.addData.Date = new Date($scope.addData.Date);
                    } else {
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Init = function () {

                $scope.addData = {
                    Date: new Date(),
                    EmployeeId: "",
                    Year: 0,
                    Month: "",
                    Remarks: "",
                    TotalEarning: 0,
                    TotalDeduction: 0,
                    EarningDeductionDetails: [],
                }

                for (var i = 0; i < 5; i++) {
                    var detail = {
                        PayrollComponentId: "",
                        Remarks: "",
                        Amount: 0,
                    }
                    $scope.addData.EarningDeductionDetails.push(detail);
                }

                var month = new Date().getMonth();
                $scope.addData.Month = $scope.Months[month];
                var year = new Date().getFullYear();
                $scope.addData.Year = year;

                if ($stateParams.VoucherId > 0) {
                    $scope.loadVoucher($stateParams.VoucherId);
                } else {
                    MainService.GetNextEarningDeductionNo().then(function (response) {
                        $scope.addData.VoucherNumber = response.data;
                    })
                }

            }
            $scope.Init();

            $scope.checkOldData = function () {

                if ($scope.addData.EmployeeId > 0, $scope.addData.Year > 0, $scope.addData.Month != "") {

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    MainService.EarningDeductionsByYear($scope.addData.EmployeeId, $scope.addData.Year, $scope.addData.Month).then(function (response) {
                        if (response.data != null && response.data != "") {
                            $scope.addData = response.data;

                            if ($scope.addData.EarningDeductionDetails == null) {
                                for (var i = 0; i < 5; i++) {
                                    var detail = {
                                        PayrollComponentId: "",
                                        Remarks: "",
                                        Amount: 0,
                                    }
                                    $scope.addData.EarningDeductionDetails.push(detail);
                                }
                            } else {

                                var length = 5 - $scope.addData.EarningDeductionDetails.length;

                                for (var i = 0; i < length; i++) {
                                    var detail = {
                                        PayrollComponentId: "",
                                        Remarks: "",
                                        Amount: 0,
                                    }
                                    $scope.addData.EarningDeductionDetails.push(detail);
                                }

                            }

                        } else {
                            $scope.addData.Id = "";
                            $scope.addData.EarningDeductionDetails = [];
                            for (var i = 0; i < 5; i++) {
                                var detail = {
                                    PayrollComponentId: "",
                                    Remarks: "",
                                    Amount: 0,
                                }
                                $scope.addData.EarningDeductionDetails.push(detail);
                            }
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                    });

                }
            }

            $scope.click = function (data) {
                $scope.SelectedCE = data;

                $scope.addData.TotalEarning = 0;
                $scope.addData.TotalDeduction = 0;
                angular.forEach($scope.addData.EarningDeductionDetails, function (e) {

                    var isEarning = false;
                    angular.forEach($scope.Components, function (a) {
                        if (e.PayrollComponentId == a.Id && a.Type == "Earnings") {
                            isEarning = true;
                        }
                    })

                    if (isEarning) {
                        $scope.addData.TotalEarning = $scope.addData.TotalEarning + e.Amount;
                    } else {
                        $scope.addData.TotalDeduction = $scope.addData.TotalDeduction + e.Amount;
                    }

                })
            }

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.addRow = function () {
                var detail = {
                    PayrollComponentId: "",
                    Remarks: "",
                    Amount: 0,
                }
                $scope.addData.EarningDeductionDetails.push(detail);
            }

            $scope.removeRow = function () {

                var index = $scope.addData.EarningDeductionDetails.indexOf($scope.ClickedRow);
                $scope.addData.EarningDeductionDetails.splice(index, 1);

            }


            $scope.Delete = function (data) {
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEarningDeduction($scope.addData.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#deleteModal').modal('hide');
                        $state.go("EarningDeductionList");
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                    $scope.load = false;
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Edit = function (data) {
                $scope.Appraisal = data;
                $scope.Appraisal.Date = new Date($scope.Appraisal);
            }


            $scope.SaveData = function () {

                if ($scope.addData.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);
                } else if ($scope.addData.Year == 0) {
                    toastr.warning($scope.LanguageData.SelectYear);
                } else if ($scope.addData.Month == 0) {
                    toastr.warning($scope.LanguageData.SelectMonth);
                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    $scope.addData.DateString = $scope.extractDate($scope.addData.Date);

                    MainService.AddEarningDeduction($scope.addData).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }






                    }])
